import styled from 'styled-components/macro'

import { Layout } from '@loadsmart/loadsmart-ui'

import { screen } from 'legacy/styles/screen'

export const ResponsiveLayoutStack = styled(Layout.Stack)`
  align-items: center;

  ${screen.md} {
    align-items: flex-start;
  }
`
